import "core-js/modules/es6.function.name";
import router from "./router";
import store from "./store";
import { Message } from 'element-ui';
import NProgress from 'nprogress'; // progress bar
import 'nprogress/nprogress.css'; // progress bar style
import { getAccessToken } from '@/utils/auth'; // get token from cookie
import getPageTitle from '@/utils/get-page-title';
NProgress.configure({
  showSpinner: false
}); // NProgress Configuration

var whiteList = ['/index', '/introduce', '/guide', '/famousCompany/index', '/famousCompany/detail']; // no redirect whitelist

router.beforeEach(function (to, from, next) {
  NProgress.start();
  document.title = getPageTitle(to.meta.title);
  var hasToken = getAccessToken();
  if (to.path === '/login') {
    if (hasToken) {
      next('/');
    } else {
      next();
    }
    NProgress.done();
  } else {
    if (hasToken) {
      var hasGetUserInfo = store.getters.name;
      if (hasGetUserInfo) {
        next();
      } else {
        try {
          // get user info
          store.dispatch('user/getInfo');
          next();
        } catch (error) {
          // remove token and go to login page to re-login
          store.dispatch('user/resetToken');
          Message.error(error || 'Has Error');
          next("/login?redirect=".concat(to.path));
          NProgress.done();
        }
      }
    } else {
      if (whiteList.indexOf(to.path) !== -1) {
        next();
      } else {
        next("/login?redirect=".concat(to.path));
        NProgress.done();
      }
    }
  }
});
router.afterEach(function () {
  // finish progress bar
  NProgress.done();
});